import React from 'react';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import Img from 'gatsby-image';
import { AppControlContext } from '../../context/AppControlContext';
import { ContainerBGStyleListTypes } from '../../utils/utils';
import ContainerBG from '../ContainerBG/container-bg';
import Modal from '../Modal/refLibModal';
import './videoLibraries.scss';

import clientConfig from '../../../client-config';
import { parseYouTubeVideoURL } from '../../utils/helper';

const VideoLibraries = ({ videosList, layoutStyle, title, ...props }) => {
  const { modalIsOpen, setModalIsOpen } = React.useContext(AppControlContext);
  const [selectedThumbnailUrl, setSelectedThumbnailUrl] = React.useState('');
  React.useEffect(() => {
    if (!modalIsOpen) setSelectedThumbnailUrl('');
  }, [modalIsOpen]);
  const renderVideoThumbnail = (videoData) => {
    return (
      <div className="video-thumbnail-wrapper">
        <button
          className="image-wrapper"
          onClick={() => {
            setSelectedThumbnailUrl(videoData?.videoUrl);
            setModalIsOpen(!modalIsOpen);
          }}
        >
          
          <Img className="img-wrap" fluid={getFluidGatsbyImage(videoData?.videoThumbnail, { maxWidth: 675, maxHeight:400}, clientConfig.sanity)} alt="alt" />
          <div className="play-icon">
            <i className="icon-play" />
          </div>
        </button>
        <div className="video-description">{videoData?.videoDescription}</div>
      </div>
    );
  };
  return (
    <div className="video-section">
      <ContainerBG styles={ContainerBGStyleListTypes.DARK}>
        <div className="container">
          <div className="video-wrapper">
            <h2 className="text-title">{title}</h2>
            <div className="video-libraries-wrapper">
              {videosList.length > 0 ? (
                videosList.map((video) => renderVideoThumbnail(video))
              ) : (
                <h4 className="no-video-text">No Videos Avaialble...</h4>
              )}
            </div>
          </div>
        </div>
      </ContainerBG>

      {modalIsOpen ? (
        <Modal>
          <iframe
            className=""
            src={parseYouTubeVideoURL(selectedThumbnailUrl)}
            id="video"
            allowscriptaccess="always"
            allow="autoplay"
            title="ld"
            width="100%"
            height="400"
          />
        </Modal>
      ) : (
        ''
      )}
    </div>
  );
};

export default VideoLibraries;
